import { render, staticRenderFns } from "./OzBox.vue?vue&type=template&id=f7cdb760&"
import script from "./OzBox.vue?vue&type=script&lang=ts&"
export * from "./OzBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OzBox.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports